const Style = (theme) => ({
  wrapper: {
    display: 'flex',
    maxWidth: 'none',
    flexDirection: 'column',
  },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    margin: '0px auto !important',
  },
});

export default Style;
